angular.module('app').controller('MessageListSettingsCtrl',
    ['$scope', 'SettingService', 'ListService', 'AprimaAnalytics',
        function ($scope, SettingService, ListService, AprimaAnalytics) {
            'use strict';

            AprimaAnalytics.sendPageView('/Settings/Message');


            var loadingOption = {
                    Description: 'Loading...'
                },
                messagesDashboardSettings = SettingService.getMessagesListSettings();

            function findById(list, id) {
                return !id || _.find(list, {'Id': id});
            }

            $scope.mode = 'locked';

            function loadSettings() {
                $scope.messageOptions = {
                    messageFilters: [loadingOption]
                };

                $scope.settings = {};

                ListService.getList('messageFilters').then(function (list) {
                    var currentMessageFilterId = messagesDashboardSettings && messagesDashboardSettings.messageFilterId;
                    $scope.messageOptions.messageFilters = list;
                    $scope.settings.messagesFilter = findById($scope.messageOptions.messageFilters, currentMessageFilterId);
                });
            }

            $scope.saveMessagesTileSettings = function () {
                SettingService.setMessagesListSettings({
                    messageFilterId: $scope && $scope.settings && $scope.settings.messagesFilter && $scope.settings.messagesFilter.Id
                });

                SettingService.updateNativeSettings();
            };

            loadSettings();
        }]);
